import React from 'react';
import { ErrorBarra } from 'errores';
import "./unsuscribe.scss";
import ButtonPrimary from '../../componentes/cupra/controls/ButtonPrimary';
import LinkButton from '../../componentes/cupra/controls/LinkButton';
import check from "./img/checkEmail.png";

class Unsuscribe extends React.Component {

    constructor(props) {
        super(props);
        this.state = { pushChecked: false, data: this.props.match.params.data, error: false, cargando: true, checked: false, errorMensaje: "", successfullUnsuscribe: false };
        this.cerrarError.bind(this);
        this.getMarcaId.bind(this);
    }

    componentDidMount() {
        this.setState({ cargando: true })
        fetch(process.env.REACT_APP_URL_DTO_BACK + "correos/cliente?data=" + this.state.data, {
            method: "GET",
        }).then(async res => {
            let responseBody = await res.json();
            if (res.status < 299) {
                this.setState({ checked: responseBody.mensaje.suscribe, cargando: false, successfullUnsuscribe: true });
            } else {
                this.setState({ error: true, errorMensaje: "¡Ups! Algo ha pasado, favor de reintentar.", cargando: false });
            }
        }).catch(errorP => {
            console.log(errorP);
            if (errorP.toString().includes("NetworkError")) {
                this.setState({ error: true, errorMensaje: "Por el momento no podemos conectar con el servicio.", cargando: false });
            } else {
                this.setState({ error: true, errorMensaje: "¡Ups! Algo ha pasado, favor de reintentar.", cargando: false });
            }
        });
    }

    enviaSuscripcion() {
        if (this.props.marca === "cupra") {
            this.setState({ pushChecked: !this.state.pushChecked });
        }
        this.setState({ cargando: true })
        let idAppMarca = -1

        if (this.props.marca === "vw") {
            idAppMarca = process.env.REACT_APP_ID_VW
        } else if (this.props.marca === "seat") {
            idAppMarca = process.env.REACT_APP_ID_SEAT
        } else if (this.props.marca === "audi") {
            idAppMarca = process.env.REACT_APP_ID_AUDI
        } else if (this.props.marca === "cupra") {
            idAppMarca = process.env.REACT_APP_ID_CUPRA
        }

        fetch(process.env.REACT_APP_URL_DTO_BACK + "correos/cliente?data=" + this.state.data, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                suscribe: !this.state.checked && this.state.pushChecked ? true : false,
                idApp: idAppMarca
            })
        }).then(async res => {
            await res.json();
            if (res.status < 299) {
                this.setState({ cargando: false, errorMensaje: "Tu solicitud ha sido procesada correctamente, ya puedes cerrar la ventana del navegador." })
            } else {
                this.setState({ error: true, errorMensaje: "¡Ups! Algo ha pasado, favor de reintentar.", cargando: false });
            }
        }).catch(errorP => {
            console.log(errorP);
            if (errorP.toString().includes("NetworkError")) {
                this.setState({ error: true, errorMensaje: "Por el momento no podemos conectar con el servicio.", cargando: false });
            } else {
                this.setState({ error: true, errorMensaje: "¡Ups! Algo ha pasado, favor de reintentar.", cargando: false });
            }
        });
    }

    cerrarError() {
        this.setState({ errorMensaje: "" });
    }

    render() {
        var cerrarError = this.cerrarError;
        return (
            <>
                {
                    this.props.marca !== "cupra" ?
                        <>
                            <div className={"container__font--" + this.props.marca}>
                                <div className={this.state.errorMensaje !== "" ? "d-block" : "d-none"}>
                                    <ErrorBarra mensaje={this.state.errorMensaje} marca={this.props.marca} cerrarError={cerrarError.bind(this)} />
                                </div>
                                <div className="container">
                                    <div className="offset-lg-2 offset-md-2 col-xs-12 col-sm-12 col-md-8 pt-5 margin__top--titulo">
                                        {this.props.marca !== "curpa" ? (
                                            <h1 className="font__title--ligth text-center">¿Quieres ser contactado?</h1>
                                        ) : (
                                            <h1 className="title-unsuscribe-cupra text-center">SIGUE TU CUPRA</h1>
                                        )
                                        }
                                    </div>
                                    <div className={"offset-lg-2 offset-md-2 col-xs-12 col-sm-12 col-md-8 mt-5"}>
                                        <p className={"d-block"}>Nos interesa mantenerte informado, por lo que te notificaremos todo tu proceso de compra.</p>
                                        <div>
                                            <p className={this.state.checked ? "d-block font-weight-bold" : "d-none"}>Si ya no quieres ser contactado, solo activa la casilla.</p>
                                            <p className={!this.state.checked ? "d-block font-weight-bold" : "d-none"}>Si quieres ser contactado, solo activa la casilla.</p>
                                        </div>
                                    </div>
                                    <div className="offset-lg-3 offset-md-3 col-xs-12 col-sm-12 col-md-6 mt-5 mb-5">
                                        <div className={"row mb-3"}>
                                            <div className="col-2">
                                                <label className={"container_check--" + this.props.marca}>
                                                    <input type="checkbox" id="2" checked={this.state.pushChecked} onChange={() => this.setState({ pushChecked: !this.state.pushChecked })} />
                                                    <span className={"check--" + this.props.marca}></span>
                                                </label>
                                            </div>
                                            <div className={"col-8 label__check--" + this.props.marca}>
                                                <label htmlFor="2"><b>Correo electrónico</b></label>
                                            </div>
                                        </div>
                                        {/*CAMBIAR SEAT CUPRA */}
                                        <>
                                            <div className="row">
                                                <div className="col mt-5">
                                                    <button className={"w-100 form__button--" + this.props.marca + "-black form__button--" + this.props.marca} onClick={() => { this.enviaSuscripcion() }} name="guardar">{this.props.marca === "cupra" ? "Descubrir" : "Guardar"}</button>
                                                </div>
                                            </div>
                                        </>
                                    </div>
                                    <div className={"page__cargando page__cargando--" + this.props.marca + (this.state.cargando ? " d-block" : " d-none")}>

                                    </div>
                                </div>
                            </div>
                        </>
                        :

                        <>

                            <div className={"container__font--cupra"}>
                                <div className={this.state.errorMensaje !== "" ? "d-block" : "d-none"}>
                                    <ErrorBarra mensaje={this.state.errorMensaje} marca={this.props.marca} cerrarError={cerrarError.bind(this)} />
                                </div>
                                <div className="container">
                                    <div className="offset-lg-2 offset-md-2 col-xs-12 col-sm-12 col-md-8 pt-5 margin__top--titulo">
                                        <div className="title-unsuscribe-cupra text-center mt-5">SIGUE TU CUPRA</div>
                                    </div>
                                    <div className={"container__unsuscribe-cupra"}>

                                        <div className={this.state.successfullUnsuscribe !== true ? "d-flex justify-content-center px-3" : "d-none"}>
                                            <p className={this.state.checked ? "" : "d-none"}>Al hacer clic en el botón dejarás de recibir actualizaciones de tu estatus en tu correo.</p>
                                            <p className={!this.state.checked ? "" : "d-none"}>Al hacer clic en el botón empezarás a recibir actualizaciones de tu estatus en tu correo.</p>
                                        </div>
                                        <div className={this.state.successfullUnsuscribe === true ? 'd-flex justify-content-center mb-4' : 'd-none'}>
                                            <img alt='check' src={check} className='container-img-check' />
                                        </div>
                                        <div className={this.state.successfullUnsuscribe !== true ? "d-none" : "d-flex justify-content-center"}>
                                            <p>¡Listo! Ya no recibirás más actualizaciones a tu correo.</p>

                                        </div>
                                        <div className={this.state.successfullUnsuscribe === true ? "d-flex justify-content-center mt-5" : "d-none"}>
                                            <LinkButton title={"Ir a la página principal"} ruta={"/seat/inicio"} />
                                        </div>
                                    </div>
                                    <div className="offset-lg-3 offset-md-3 col-xs-12 col-sm-12 col-md-6 mt-5 mb-5">
                                        <>
                                            <div className={this.state.successfullUnsuscribe !== true ? "d-flex justify-content-center mt-5" : "d-none"}>
                                                <ButtonPrimary style={{ marginTop: '30px' }} onClick={() => { this.enviaSuscripcion() }} textButton={"Desuscribir"} />
                                            </div>
                                        </>
                                    </div>
                                    <div className={"page__cargando page__cargando--" + this.props.marca + (this.state.cargando ? " d-block" : " d-none")}>

                                    </div>
                                </div>
                            </div>
                        </>
                }
            </>
        );
    }
}

export default Unsuscribe;